import type { planning as planningEn } from "../en/planning";

export const planning: typeof planningEn = {
  filters: {
    allDestinations: "Všechny destinace",
    allGarants: "Všichni garanti",
    allLifecycles: "Všechny stavy",
    allGuides: "Všichni průvodci",
  },
  calc: {
    empty: "Zatím žádná kalkulace — sestavte zde nákladový plán, marži a prodejní cenu.",
    newCalculation: "Nová kalkulace",
    new: "Nová",
    defaultTitle: "Kalkulace",
    activate: "Aktivovat",
    activateHint: "Nastaví tuto kalkulaci jako zdroj pravdy pro aplikaci/REAL (ostatní degraduje)",
    applied: "aplikováno {{date}}",
    deleteTitle: "Smazat kalkulaci",
    deleteMessage:
      "Smazat „{{title}}“? Položky se smažou s ní. Aplikované ceny na zájezdu/objednávce zůstávají beze změny.",
    dayTransportItem: "Den {{day}} — doprava",
  },
  params: {
    title: "Parametry",
    paxCount: "Počet osob v kalkulaci",
    commissionPct: "Provize %",
    markupPct: "Přirážka %",
    modeMarkup: "přirážka",
    modeCommission: "provize",
    marginModeHint:
      "Stejná matematika — jen jiný název (přirážka u skupinových vs. provize FIT-DMC)",
    sellCurrency: "Prodejní měna",
    intlFlightPerPax: "Mezinárodní let / os.",
    passThrough: "(průchozí položka)",
    roundingStep: "Krok zaokrouhlení",
    sensitivityPax: "Citlivostní počty osob (oddělené čárkou, prázdné = auto)",
    fxRates: "Kurzy měn (1 jednotka = N CZK)",
    refreshFromSettings: "Načíst z nastavení",
    removeRate: "Odebrat kurz",
  },
  items: {
    title: "Nákladové položky ({{count}})",
    byDay: "po dnech",
    byDayHint: "Denní mřížka jako v excelu — jen pořadí zobrazení, výpočet běží nad součty",
    prefillFromItinerary: "Předvyplnit z itineráře",
    importFromComponents: "Importovat z komponent",
    addItem: "Přidat položku",
    empty:
      "Žádné nákladové položky — přidejte je ručně, z katalogu komponent, nebo je předvyplňte z itineráře.",
    colCategory: "Kategorie",
    colCost: "Náklad",
    colCur: "Měna",
    colScope: "Rozsah",
    colQty: "Množ.",
    colOcc: "Obs.",
    colOccHint: "jen pro položky na pokoj",
    colDay: "Den",
    itemNamePlaceholder: "Název položky",
    catalogChip: "⛓ katalog",
    catalogChipHint: "Propojeno s katalogem",
    addFromCatalog: "Přidat z katalogu komponent…",
    perGroup: "na skupinu",
    perPax: "na osobu",
  },
  sellLines: {
    title: "Prodejní řádky",
    subtitle: "jak se prodejní cena rozpadá na smlouvě/nabídce — řádek 1 pohlcuje zbytek",
    addLine: "Přidat řádek",
    defaultLineLabel: "Cena zájezdu",
    newLineLabel: "Nový řádek",
    empty:
      "Jediný řádek — celá prodejní cena jako „Cena zájezdu“. Přidejte řádky pro rozdělení (např. balíček aktivit, NZETA).",
    defaultHint: "výchozí — dostává zbytek",
    margin: "marže",
    perPaxValue: "{{value}} / os.",
    unnamed: "(bez názvu)",
    saveFirstHint: "pro přiřazení nově přidaných položek nejdřív uložte",
  },
  results: {
    title: "Výsledky",
    livePreview: "živý náhled — neuloženo",
    nettoPerPax: "Netto / os. ({{count}} os.)",
    programPerPax: "Program / os. (+{{pct}} % {{mode}})",
    intlFlightPerPax: "Mezinárodní let / os.",
    sellPricePerPax: "PRODEJNÍ CENA / os.",
    profitPerPax: "Zisk / os. · celkem při {{count}}",
    singleSupplement: "Příplatek za jednolůžkový",
    computedValue: "vypočteno {{value}} {{currency}}",
    overrideHint: "Ruční přepis — prázdné použije vypočtenou hodnotu na pokoj",
    noTripLength: "chybí délka zájezdu — pro nacenění nastavte trvání",
    perPaxValue: "{{value}} / os.",
    insuranceMeta_one: "({{count}} den, tabulka {{version}})",
    insuranceMeta_few: "({{count}} dny, tabulka {{version}})",
    insuranceMeta_other: "({{count}} dní, tabulka {{version}})",
    outsideTable: "mimo tabulku — naceňte ručně",
    sensitivityTitle: "Citlivost obsazenosti · break-even {{breakEven}}",
    bePax: "{{count}} os.",
    beNever: "nikdy",
    colPax: "Os.",
    colProfitTotal: "Zisk celkem",
    colProfitPerPax: "/ os.",
  },
  actions: {
    title: "Akce",
    saveFirst: "Nejdřív uložte — akce pracují s uloženou kalkulací.",
    applyToTrip: "Aplikovat na zájezd…",
    pushToComponents: "Odeslat do komponent",
    pushHint:
      "Přidá položky propojené s katalogem, které chybí v záložce Komponenty zájezdu. Nikdy neupravuje ani nemaže existující řádky.",
    pushAdded: "Přidáno {{count}}",
    pushAlready: "již přítomno {{count}}",
    pushNoLink: "bez vazby na katalog {{count}}",
    generateOrderItems: "Vygenerovat položky objednávky…",
    applyTitle: "Aplikovat {{amount}} na zájezd",
    updatePriceFrom: "Aktualizovat „cenu od“ zájezdu",
    updateSingleSupplement: "Aktualizovat příplatek za jednolůžkový pokoj",
    noDepartures: "Tento zájezd nemá žádné termíny.",
    currentPrice: "(nyní {{price}})",
    genPreviewTitle: "Položky objednávky po vygenerování",
    genReplaced_one: "Nahradí {{count}} dříve vygenerovanou položku",
    genReplaced_few: "Nahradí {{count}} dříve vygenerované položky",
    genReplaced_other: "Nahradí {{count}} dříve vygenerovaných položek",
    genKept_one: "ponechá {{count}} ruční položku",
    genKept_few: "ponechá {{count}} ruční položky",
    genKept_other: "ponechá {{count}} ručních položek",
    writeItems: "Zapsat položky",
  },
  real: {
    title: "REAL — plán vs. realita",
    pickDeparture: "Vyberte termín…",
    load: "Načíst",
    colCategory: "Kategorie",
    colPlan: "Plán",
    colBooked: "Rezervováno",
    colActual: "Skutečnost",
    totalWithCurrency: "Celkem ({{currency}})",
    revenue: "Tržby",
    cost: "náklady",
    bookings_one: "{{count}} rezervace",
    bookings_few: "{{count}} rezervace",
    bookings_other: "{{count}} rezervací",
  },
  season: {
    subtitle: "Celý prodejní kvartál v jednom pohledu — kódy, garant, obsazenost a go/no-go.",
    empty: "V tomto období nejsou žádné termíny",
    deadlineDeposit: "Záloha",
    deadlineFoc: "FOC",
    deadlineTicket: "Ticketing",
    overdue: "{{count}} d po termínu",
    today: "dnes",
    inDays: "{{count}} d",
    atRiskHint: "{{amount}} {{currency}} v riziku na neprodaných místech",
    inheritedGarant: "Zděděno z destinace: {{name}}",
    noGarant: "— nikdo —",
    waitlistShort: "+{{count}} náhr.",
    openVelin: "Otevřít velín",
  },
  schedule: {
    subtitle:
      "Přiřazení průvodců napříč sezónou — přetažením přeplánujete, engine hlídá překryvy a těsné návaznosti.",
    conflicts_one: "{{count}} konflikt",
    conflicts_few: "{{count}} konflikty",
    conflicts_other: "{{count}} konfliktů",
    quarter: "Kvartál",
    sixWeeks: "6 týdnů",
    jumpToNow: "Zpět na dnešek",
    today: "Dnes",
    onlyConflicts: "Jen konflikty",
    emptyGuides: "Žádní aktivní průvodci k plánování",
    guideColumn: "Průvodce",
    fallbackPool: "Ostatní destinace — záložní pool ({{count}})",
    unassignedTitle: "Nepřiřazené termíny",
    unassignedHint: "přetažením na průvodce přiřadíte (předběžně)",
    allAssigned: "Každý prodejný termín má potvrzeného hlavního průvodce 🎉",
    homeDestination: "Domovská destinace: {{name}}",
    assignmentFallback: "Přiřazení",
    departureFallback: "Termín",
    tentativeSuffix: "(předběžně)",
    role: "Role",
    makeTentative: "Změnit na předběžné",
    findReplacement: "Najít náhradu",
    whoCanCover: "Kdo to může převzít?",
    noOtherGuides: "Žádní další aktivní průvodci.",
    removeFromDeparture: "Odebrat z termínu",
    openDepartureVelin: "Otevřít velín termínu →",
  },
};
